import(/* webpackMode: "eager", webpackExports: ["GoogleOAuthProvider"] */ "/var/www/askpaul_web/node_modules/@react-oauth/google/dist/index.esm.js");
;
import(/* webpackMode: "eager" */ "/var/www/askpaul_web/node_modules/next-axiom/dist/webVitals/components.js");
;
import(/* webpackMode: "eager" */ "/var/www/askpaul_web/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/var/www/askpaul_web/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/askpaul_web/src/lib/antd-registry.tsx");
